import { render } from "./PremiumBuy.vue?vue&type=template&id=28c81fa5&ts=true"
import script from "./PremiumBuy.vue?vue&type=script&lang=ts"
export * from "./PremiumBuy.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__